export function getProfileFlagsFromUrl(search: string) {
  const params = new URLSearchParams(search);
  return {
    isExistingProfile: params.get('existing') === 'true',
    isNewProfile: params.get('newProfile') === 'true',
  };
}
